// import { LOGON_METHOD } from "../../entities/sys-constants";

import FacebookIcon from '@mui/icons-material/Facebook';
import { Button } from '@mui/material';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import AppText from '../../components/atoms/AppText';
import { LOGON_METHOD } from '../../components/entities/sys-constants';
import { default as ILogin, default as IUser } from '../../components/entities/user';
import { addLog } from '../../redux/slices/log';
import { clearUser, setUser } from '../../redux/slices/user';
import { store } from '../../redux/store';
import { registerUser, setCredentials } from './auth.service';

export default function SignInWithFacebook(onSuccess: any) {
    async function getUserInfo(u: any) {
        const loginUser: ILogin = {
            userId: u.id,
            email: u.email,
            userName: u.name,
            photoUrl: u.photoUrl,
            logonMethod: LOGON_METHOD.FACEBOOK,
            password: 'temp@123',
            accountType: 1
        };

        if (u.email === undefined) {
            loginUser.email = loginUser.userId + '@facebook.com';
        }

        await registerUser(loginUser)
            .then(async (res: any) => {
                if (res.status === 'Failed') {
                } else {
                    const authResponse = res.payload;
                    setCredentials({
                        accessToken: authResponse.accessToken,
                        refreshToken: authResponse.refreshToken
                    });

                    const appUser: IUser = {
                        accountType: 0
                    };

                    appUser.email = loginUser.email;
                    appUser.userName = authResponse.userName;
                    appUser.firstName = authResponse.firstName;
                    appUser.lastName = authResponse.lastName;
                    appUser.id = authResponse.id;
                    appUser.logonMethod = authResponse.logonMethod;
                    appUser.accessToken = authResponse.accessToken;
                    appUser.refreshToken = authResponse.refreshToken;
                    appUser.userId = u.id;

                    appUser.gender = res.payload.gender;
                    appUser.address = res.payload.address;
                    appUser.photoUrl = res.payload.photoUrl;
                    appUser.phoneNumber = res.payload.phoneNumber;
                    appUser.telegramNumber = res.payload.telegramNumber;
                    appUser.whatsappNumber = res.payload.whatsappNumber;

                    appUser.companyAddress = res.payload.companyAddress;
                    appUser.companyFacebook = res.payload.companyFacebook;
                    appUser.companyLinkedin = res.payload.companyLinkedin;
                    appUser.companyMobile = res.payload.companyMobile;
                    appUser.companyName = res.payload.companyName;
                    appUser.companyWebSite = res.payload.companyWebSite;
                    appUser.companyYoutube = res.payload.companyYoutube;
                    appUser.accountType = res.payload.accountType;
                    appUser.companyInstagram = res.payload.companyInstagram;
                    appUser.backgroundImage = res.payload.backgroundImage;

                    //    sessionStorage.setItem('UserInfo', JSON.stringify(appUser));
                    store.dispatch(setUser(appUser));
                    store.dispatch(addLog('Facebook login successfully'));
                    //window.location.href = '/home';
                }
            })
            .catch(async (e) => {
            });
    }

    const responseFacebook = async (response: any) => {
        await getUserInfo(response);
        //onSuccess();
        store.dispatch(addLog('responseFacebook'));
    };

    return (
        <FacebookLogin
            appId="3782192122063357"
            fields="name,email,picture"
            callback={responseFacebook}
            render={(renderProps: any) => (
                <Button startIcon={<FacebookIcon sx={{ color: '#4267B2' }} />} variant="outlined" fullWidth sx={{ color: 'text.primary' }} onClick={renderProps.onClick}>
                    <AppText textSize={8} style={null}>
                        Facebook
                    </AppText>
                </Button>
            )}
        />
    );
}

export async function facebookSignOut() {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('UserInfo');
    store.dispatch(clearUser());
}
